import { rewardsAuthApiClientToken } from "@apps/rewards/tokens";
import type ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import type { Observable } from "rxjs";
import { map } from "rxjs";
import { create } from "superstruct";
import { inject, singleton } from "tsyringe";

import type { BoostCampaignResponseType } from "../models/RewardsBoostCampaignEntities";
import { BoostCampaignResponseSchema } from "../models/RewardsBoostCampaignSchemas";

@singleton()
class RewardsBoostCampaignApiService {
    constructor(
        @inject(rewardsAuthApiClientToken)
        private readonly apiClient: ApiClientInterface
    ) {}

    getActiveBoostCampaign(): Observable<BoostCampaignResponseType> {
        return this.apiClient
            .get({
                url: "/general/getActiveBoostCampaign",
                responseType: "json",
            })
            .pipe(
                map((value) => create(value.body, BoostCampaignResponseSchema))
            );
    }
}

export default RewardsBoostCampaignApiService;
